// it is a common practice to use all uppercase for config constants

export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '4fef75f3-d6ef-4e22-8933-15cb70849404';
export const MODAL_CLOSE_SEC = 2.5;
